// extracted by mini-css-extract-plugin
module.exports = {"footer":"AuthFooter_footer__1qVG-","address":"AuthFooter_address__tYEn8","link":"AuthFooter_link__arvzv"};